import React, { useContext, useState,useEffect } from 'react';
import { Row, Col, Form, Tabs, DatePicker, Space, Modal, message } from 'antd';
import ConfirmModal from '../partials/otp-modal';
import {
  Button,
  Input,
  Layout,
  Select,
  Phone,
  MessageSteps,
  InfoBox,
  Footer,
} from 'components';
import classNames from 'classnames';

import { useHistory, useParams } from 'react-router-dom';
import MessagesSummary from '../messages-summary';

import ArrowRight from 'assests/icons/arrow-right';

import './steps.less';
import './delivery-time.less';
import ArrowLeft from 'assests/icons/arrow-left';
import SelectDatePicker from 'components/Select/datepicker';
import { DimensionsContext } from 'context/dimensions.context';
import { customMessages } from 'utils';
import * as infoService from 'services/info.service';
import * as campaignService from 'services/campaign.service';

import moment from 'moment';
import { fetchLastAgreement, updateAgreement } from 'services/agreement.service';
import { useJob } from 'context/job.context';
import { useSelector} from 'react-redux';

const dateFormat = 'YYYY-MM-DD';
const dateFormatWithHour = 'DD/MM/YYYY HH:mm';
const DeliveryTime = (props) => {
  const { currentJob, setCurrentJob } = useJob();
  var currentDate=new Date(new Date().getTime() + (1 * 60000));
  const history = useHistory();
  const { isPc } = useContext(DimensionsContext);
  const [form] = Form.useForm();
  const [modalSummary, setModalSummary] = useState(false);
  const [modalAgreement, setModalAgreement] = useState(false);
  const [agreement, setAgreement] = useState('');
  const {loading, setLoading} = useSelector(state=>state.loader);
  const [valid, setValid] = useState(false);
  const [startHour, setStartHour] = useState(9);
  const [endHour, setEndHour] = useState(21);

  const [modalConfirm, setModalConfirm] = useState(false);
  const [loadingCCToken, setLoadinCCToken] = useState(false);


  const [messageType, setMessageType] = useState(currentJob?.messageType ? currentJob?.messageType : 0);
  const [startDate, setStartDate] = useState(moment(currentDate, dateFormat));
  
  const [createCampaignData, setCreateCampaignData] = useState(currentJob);


  const onValuesChange = () => {
    setValid(true);
    form.validateFields().then(values => {
      setValid(true);
    }).catch(
      errorInfo => {  
        if (errorInfo.errorFields.length>0)
        {
          setValid(false);
        }
    });
  };

  const onSelectedChage = (e) => {
    setStartDate(e);
  }

  const onApproveAgreement = () => 
  {
    updateAgreement()
    .then((result) => {    
      message.success("Başarıyla Kayıt Edildi.");
      setModalAgreement(false);
    }).catch((response) => {
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
    });
  }

  const createCampaign = () => {
    console.log(createCampaignData);
    createCampaignData.startDate=startDate.valueOf();
    createCampaignData.parameterType = createCampaignData.paramType;
    createCampaignData.messageText=createCampaignData.messageWithoutEtk;
    createCampaignData.endDate=null;
    campaignService.createCampaign(createCampaignData)
    .then((result) => {    
      history.push(`/ReportsPage`);
    }).catch((response) => {
      if (response.responseCode=="1100")
      {
      
        fetchLastAgreement().then((response) => {
          setAgreement(response);
          setModalAgreement(true);
        }).catch((response) => {
          Modal.error({
            title: 'Hata',
            content: customMessages.getMessage(response.responseCode),
          });
        });
      }
      else{
        Modal.error({
          title: 'Hata',
          content: customMessages.getMessage(response.responseCode),
        });
      }
    });
}

  useEffect(() => {
    infoService.getWorkingHours().then((result) => {
      setStartHour(result.properties.startHour);
      setEndHour(result.properties.endHour);
      onValuesChange();
    }).catch((response) => {
      message.error(customMessages.getMessage(response.responseCode));
    });
  }, [])

  return (
 
      <div className="delivery-time-page">
        <Form
          form={form}
          onValuesChange={onValuesChange}
          name="choose-title"
        >
          <div
            className={classNames('step-transitions', {
              'padding-spaces-none': !isPc,
            })}
          >
            <div className="container">
              <div className="step-transitions_left"></div>
              {isPc ? (
                <div className="step-transitions__right">
                  <Button type="ghost" className="circle"   onClick={()=>  props.updateCurrent(messageType==3 ? 1:2)}>
                    <ArrowLeft />
                  </Button>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="ant-btn--icon"
                    onClick={() => {
                      setModalSummary(true);
                    }}
                    disabled={!valid}
                  >
                    Gönderim Onayı
                    <ArrowRight />
                  </Button>
                </div>
              ) : null}
            </div>
          </div>
          <div className="page-content">
            <div className="container">
              <Row>
                <Col md={24} lg={24} xl={10} span={24}>
                  <div className="delivery-detail">
                    <h3 className="box__title">Gönderim Zamanını Seçin</h3>
                    <Form.Item rules={[{ required: true }]} name="startDate" initialValue={startDate}>
                      <SelectDatePicker
                      defaultValue={startDate}
                        label="Tarih Seçimi"
                        formName="clock"
                        hours
                        onChange={onSelectedChage}
                        hourStart={startHour}
                        hourEnd={endHour}
                      />
                    </Form.Item>
                  </div>
                </Col>
                <Col
                  s={24}
                  md={{ span: 11, offset: 2 }}
                  lg={{ span: 11, offset: 2 }}
                  xl={{ span: 6, offset: 8 }}
                  span={24}
                >
                  <div>
                  <MessagesSummary
                                 
                                 title={currentJob?.sender}
                                 deliveryTime ={startDate.format(dateFormatWithHour)}
                                 message={currentJob?.messageText}
                                 receivers={currentJob?.receivers}
                                 reportName={currentJob?.campaignName}
                                 numbersOfSms={currentJob?.maxCredit}
                    />
                  </div>
                </Col>
              </Row>
            </div>
            {!isPc ? (
              <div className="step-transitions__right">
                <Button type="ghost" className="circle"   onClick={()=>  props.updateCurrent(2)}>
                  <ArrowLeft />
                </Button>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="ant-btn--icon"
                  onClick={() => {
                    setModalSummary(true);
                  }}
                  disabled={!valid}
                >
                  Gönderim Onayı
                  <ArrowRight />
                </Button>
              </div>
            ) : null}
          </div>
        </Form>
        <Modal
        title="Özet"
        visible={modalSummary}
        className="modal-summary"
        onCancel={() => setModalSummary(false)}
        footer={[
          <div className="modal-action">
            <Button
              shape="round"
              type="ghost"
              onClick={() => setModalSummary(false)}
            >
              Vazgeç
            </Button>
            <Button loading={loading}
              key="confirm"
              type="primary"
              onClick={() => {
                setModalConfirm(true);
                
                //setModalSummary(false);
              }}
            >
              Onayla
            </Button>
            
            <ConfirmModal 
            showModal={modalConfirm} 
            loading={loadingCCToken} 
            toggleModal={setModalConfirm}  
            onConfirmSale={createCampaign} 
            receivers={currentJob?.receivers} 
            smsContent ={currentJob?.messageWithoutEtk}/>
            
          </div>,
        ]}
      >
        <div className="summary-content">
          <div className="summary-content__row">
            <strong>Ünvanınız</strong>
            <span>{currentJob?.sender}</span>
          </div>
          <div className="summary-content__row">
            <strong>Mesaj İçeriği</strong>
            <p>
            {currentJob?.messageText}
            </p>
          </div>
          <div className="summary-content__row">
            <strong>Gönderim Zamanı</strong>
            <span>{startDate.format(dateFormatWithHour)}</span>
          </div>
          <div className="summary-content__row">
            <strong>Rapor Adı</strong>
            <span>{currentJob?.campaignName}</span>
          </div>
          <div className="summary-content__row multiple">
            <div>
              <strong>Alıcılar</strong>
              <span>{currentJob?.receivers} Kişi</span>
            </div>
            <div>
              <strong>Harcanacak Tutar</strong>
              <span>{currentJob?.maxCredit} Kredi</span>
            </div>
          </div>
        </div>
        <InfoBox type="warning" content={
            <span className="info-text"> 
         
            Mesaj oluşturmayı tamamlamak ve gönderim işlemini{' '}
            <span>planlanan saatte</span> başlatmak için gönderimi onayla butonuna
            tıklayınız. 
            <p>Onayla butonuna tıkladıktan sonra şirket yetkili telefon numaranıza <strong>(ÖŞY)</strong> 
             gönderilecek olan tek kullanımlık şifreyi girmeniz gerekmektedir.
            </p>
          </span>
          }/>
        
      </Modal>

      <Modal
        title="Sözleşme Onaylama"
        visible={modalAgreement}
        onCancel={() => setModalAgreement(false)}
        footer={[
          <div className="modal-action">
            <Button
              shape="round"
              type="ghost"
              onClick={() => setModalAgreement(false)}
            >
              Vazgeç
            </Button>
            <Button
              key="confirm"
              type="primary"
              onClick={() => {
                onApproveAgreement();
              }}
            >
              Onayla
            </Button>
          </div>,
        ]}
      >
        <span className="info-text">
          Sözleşmemiz güncellendi. Gönderim oluşturabilmek için yeni sözleşmeyi onaylamanız gerekmektedir.
        </span>
         <InfoBox htmlContent={agreement} />
     
       
      </Modal>

      
      </div>

     
  );
};

export default DeliveryTime;
